import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// react-markdown 3 parsed GitHub-flavoured markdown by default: tables, autolinks, strikethrough
const remarkPlugins = [remarkGfm];

interface MarkdownProps {
    children: string;
}

const Markdown = ({ children }: MarkdownProps) => (
    <ReactMarkdown remarkPlugins={remarkPlugins}>{children}</ReactMarkdown>
);

export default Markdown;
